import styles from "./progressLine.module.css"

const startColor = "var(--app-start-color)";
const midColor = "var(--app-mid-color)";
const endColor = "var(--app-end-color)";

export const ProgressLine = ({ progress, height = 6 }) => {
    const color = (progress < .34) ? startColor : (progress < .67) ? midColor : endColor;
    return (
        <div className={styles.progress_line} style={{height}}>
            <div className={styles.progress_line_front}
                
                style={{ width: `${progress * 100}%`, height, backgroundColor: color }}
            />
        </div>
    )
}